<template>
  <v-sheet height="56px">
    <v-app-bar fixed class="header-mobile elevation-1" color="primary">
      <router-link to="/">
        <img
          v-if="informations.img"
          src="../../../assets/img/logo-footer.svg"
          :alt="informations.name"
          height="46px"
          class="d-block"
        />
      </router-link>
      <v-spacer />

      <template v-for="(item, i) in social">
        <v-btn
          v-if="item"
          :key="i"
          target="_blank"
          :href="item.link"
          class="mr-1 d-flex"
          width="40px"
          height="40px"
          icon
        >
          <v-icon color="white" size="20">
            {{ item.icon }}
          </v-icon>
        </v-btn>
      </template>
      <v-app-bar-nav-icon color="white" @click="drawer = !drawer" />
    </v-app-bar>

    <v-navigation-drawer color="primary" v-model="drawer" fixed temporary>
      <router-link to="/" class="d-flex px-2 py-4">
        <img
          src="../../../assets/img/logo-footer.svg"
          :alt="informations.name"
          width="100%"
          class="px-6"
        />
      </router-link>
      <v-divider />
      <v-list v-model="current" class="mt-2" nav>
        <template v-for="({ text, to, dropdown }, i) in menu">
          <v-list-item v-if="to" :key="i" :to="to" link>
            <v-list-item-content>
              <v-list-item-title class="text-body-2 white--text">
                {{ text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group
            v-else
            :key="`${i}d`"
            :value="false"
            color="secondary"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-title class="text-body-2 white--text">
                {{ text }}
              </v-list-item-title>
            </template>

            <v-list-item
              v-for="({ text, to }, i) in dropdown"
              :key="i"
              :to="to"
              class="pl-10"
              link
            >
              <v-list-item-content>
                <v-list-item-title class="text-body-2 white--text">
                  {{ text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>

      <div v-if="informations.whatsapp_float" class="px-3">
        <v-btn
          class="text-none mt-3"
          :href="informations.whatsapp_float"
          target="_blank"
          color="white"
          depressed
          outlined
          rounded
          block
        >
          <v-icon color="white" size="18" left> fa-whatsapp </v-icon>
          {{ informations.float_whatsapp_title || "Faça conosco" }}
        </v-btn>
      </div>
    </v-navigation-drawer>
  </v-sheet>
</template>

<script>
import { getSocial } from "../../../utils/getSocial";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      current: this.$route.path,
      drawer: false,
    };
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
  },
};
</script>

<style lang="scss" scoped>
.header-mobile {
  z-index: 99 !important;
}
</style>

<style>
.v-navigation-drawer__content .navbar-brand {
  height: 70px;
}

.v-list-item__icon .v-icon {
  font-size: 14px !important;
  color: white !important;
}
</style>
